import { render, staticRenderFns } from "./JdpAdminUsers.vue?vue&type=template&id=72f28ba6&scoped=true&"
import script from "./JdpAdminUsers.vue?vue&type=script&lang=ts&"
export * from "./JdpAdminUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f28ba6",
  null
  
)

export default component.exports